import { render, staticRenderFns } from "./NodeQuizSingle.vue?vue&type=template&id=38d124e2"
import script from "./NodeQuizSingle.vue?vue&type=script&lang=js"
export * from "./NodeQuizSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports